import { render, staticRenderFns } from "./RightWrite.vue?vue&type=template&id=58582fb7&scoped=true&"
import script from "./RightWrite.vue?vue&type=script&lang=js&"
export * from "./RightWrite.vue?vue&type=script&lang=js&"
import style0 from "./RightWrite.vue?vue&type=style&index=0&id=58582fb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58582fb7",
  null
  
)

export default component.exports